export enum AttributeKey
{
    CURRENT_USER = 'current_user',
    LAST_SYNC = 'last_sync',
    CONSTANCE = 'constance_config'
}

export interface Attribute
{
    [key: string]: any;
    key: string;
    value?: any;
}

export interface CurrentUser extends Attribute
{
    id: number;
    language: string;
    token: string;
}